export default __webpack_public_path__ + "static/calendars-unite-mobile-5f9adfecb9b74767363fc293f17f4133.svg";